/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Bell = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M16.6 13.4c-.7-.7-1.6-1.6-1.6-4.9C15 6 13.2 4 10.8 3.6c.1-.2.2-.4.2-.6 0-.6-.4-1-1-1s-1 .4-1 1c0 .2.1.4.2.6C6.8 4 5 6 5 8.5c0 3.4-.9 4.2-1.6 4.9-.9 1-.2 2.6 1.1 2.6H8c0 1.1.9 2 2 2s2-.9 2-2h3.5c1.3 0 2-1.6 1.1-2.6zM10 16.8c.1 0 .2.1.2.2s-.1.2-.2.2c-.7 0-1.2-.6-1.2-1.2h.5c-.1.4.3.8.7.8z" />
  </svg>
);

export default extendIcon(Bell);
